import React, { useEffect } from "react";
import CircleLoader from "../notes/component/CircleLoader";
import { isAndroidDevice, isMobile } from "../../helper/CommonFuncs";
const RequestATemplate = () => {
   useEffect(() => {
      const query = new URLSearchParams(window.location.search);
      const email = query.get("email");
      const first_name = query.get("first_name");
      const last_name = query.get("last_name");
      const client = query.get("client");
      const isTrialUser = query.get("is_trial_user") || null;
      const isProd = window.location.host === "pro.playbackhealth.com";
      const url = `https://playbackhealth.typeform.com/to/${
         isProd ? "Q9n08fGW" : "SNRJxzT9"
      }#email=${email}&first_name=${first_name}&last_name=${last_name}&client=${client}&is_trial_user=${isTrialUser}`;
      window.location.href = url;
   }, []);

   const isNotIos = isAndroidDevice() || !isMobile();

   return <div class=" flex-center h-100 ">{isNotIos && <CircleLoader />}</div>;
};

export default RequestATemplate;
